// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-radio_default__2wder","inner":"idt-radio_inner__zc-tg","check":"idt-radio_check__1btqb","checkInner":"idt-radio_checkinner__3v3gn","active":"idt-radio_active__317hu"};